import styled from '@emotion/styled'

export const ToggleContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`
